<div class="bordered-product">
    <img class="bordered-product__img" [src]="imageSrc" alt="">
</div>